// import type { AxiosPromise, AxiosRequestConfig, Method } from "axios";
const AxiosPromise = {};
const AxiosRequestConfig = {};
const Method = {};
import axios from "axios";

// import { CONFIG } from '@/config';
const CONFIG = {};

const basicRequest = axios.create({
  baseURL: `${CONFIG.api}/api`,
  timeout: 100000,
});
if (window.sessionStorage.getItem("token")) {
  basicRequest.interceptors.request.use((res) => {
    res.headers.common.Authorization =
      window.sessionStorage.getItem("token") || "";
    return res;
  });
}

type RequestAPI = {
  [key in Method]: <T extends unknown>(...args: any[]) => AxiosPromise<T>;
};
const apiMethods = ["get", "post", "delete", "put", "patch"] as Method[];

const request: Record<string, RequestAPI> = new Proxy(
  {},
  {
    get(target, name) {
      return {
        ...apiMethods.reduce((obj, method) => {
          // eslint-disable-next-line no-param-reassign
          obj[method] = (...args: any[]) => {
            const path = name
              .toString()
              .replace(/([a-z])([A-Z])/g, "$1/$2")
              .replace(/\$/g, "/$/")
              .toLowerCase();
            const url = path.replace(/\$/g, () => args.shift());
            const requestConfig: AxiosRequestConfig = {
              url:
                url[url.length - 1] === "/"
                  ? url.slice(0, url.length - 1)
                  : url,
              method: method as Method,
            };
            if (method === "get" || method === "delete") {
              requestConfig.params = args.shift() || {};
            } else {
              requestConfig.data = args.shift() || {};
            }
            return basicRequest(requestConfig);
          };
          return obj;
        }, {} as RequestAPI),
      };
    },
  }
);

export default request;
